document.addEventListener('click', function(event) {
  if (event.target.classList.contains('product-samples-widget__close')) {
    document.querySelector('[data-samples-widget-close]').click();
  }
});

window.ProductSample = window.ProductSample || {};
if(typeof ProductSample === 'undefined') {
  var ProductSample = {};
};
ProductSample.loadSamplesButton = true;
  
function handleSampleChange(result) {

  const cartItems = window.liquidAjaxCart.cart.items; 
  localStorage.setItem('savedCartItems', JSON.stringify(cartItems));

  const data = JSON.parse(localStorage.getItem('product_samples'));
  const sampleIds = Object.keys(data)
    .filter(key => key !== "order_id")
    .map(key => {
      const sampleVariant = data[key].variants.find(variant => variant.title === "Sample");
      return sampleVariant ? `${sampleVariant.id}:1` : '';
    })
    .filter(id => id !== '')
    .reverse()
    .join(',');

  const button = document.querySelector('button[data-samples-widget-checkout-lgx]');
  button.innerText = "Processing...";
  button.disabled = true;
  button.style.cursor = "not-allowed";
  button.style.opacity = "0.5";
  document.body.style.pointerEvents = 'none';

  setTimeout(() => {
    window.location.href = `https://blindstyle.co.uk/cart/${sampleIds}`;
  }, 300);
}
